import { Box, Tag } from '@factorialco/deprecated-design-system'
import {
  TrainingsSessionAttendanceStatusEnum,
  UpdateMyTrainingsSessionAttendancesDocument,
} from 'generated/resources/graphql'

import PopoverMenu from 'modules/core/components/PopoverMenu'
import { useMutation } from 'modules/core/hooks/useMutation'
import { handleResult } from 'modules/core/lib/handleMutation'
import i18n from 'modules/core/lib/i18n'
import app from 'modules/core/store/models/app'

import { useTrainingsDatatable } from 'modules/trainings/hooks/useTrainingsDatatable'

type PopoverOption = {
  label: string
  value: TrainingsSessionAttendanceStatusEnum
}

export function StatusTag<SA extends { id: string; status: string }>({
  canEditAttendance,
  sessionAttendance,
}: {
  canEditAttendance: boolean
  sessionAttendance: SA
}) {
  const [updateSessionAttendances] = useMutation(UpdateMyTrainingsSessionAttendancesDocument, {
    extractorFn: (data) => data.trainingsMutations.bulkUpdateTrainingsSessionAttendance,
  })
  const { getSessionAttendanceTranslation, parseAttendanceStatus, getSessionAttendanceColor } =
    useTrainingsDatatable()
  const onSubmit = async (newStatus: TrainingsSessionAttendanceStatusEnum) => {
    if (sessionAttendance) {
      const result = await updateSessionAttendances({
        variables: {
          ids: [sessionAttendance.id],
          status: newStatus,
        },
      })
      const handled = handleResult(result, () => {
        app.setFlash({
          type: 'wrong',
          message: i18n.t('trainings.trainings_detail.training_details_updated'),
        })

        return
      })

      if (handled.success) {
        app.setFlash({
          type: 'correct',
          message: i18n.t('trainings.trainings_detail.training_details_updated'),
        })
      }
      return handled
    } else {
      app.setFlash({
        type: 'wrong',
        message: i18n.t('trainings.trainings_detail.training_details_updated'),
      })
    }
  }

  const sessionAttendanceStatus: PopoverOption[] = [
    {
      value: 'pending',
      label: i18n.t('trainings.session_access_membership_table.not_started'),
    },
    {
      value: 'inprogress',
      label: i18n.t('trainings.session_access_membership_table.started'),
    },
    {
      value: 'missing',
      label: i18n.t('trainings.session_access_membership_table.absent'),
    },
    {
      value: 'completed',
      label: i18n.t('trainings.session_access_membership_table.completed'),
    },
  ]

  return (
    <Box width="fit-content">
      <PopoverMenu type="list">
        <PopoverMenu.Trigger disabled={!canEditAttendance}>
          <Tag
            showCircle
            showActionIcon={canEditAttendance}
            rightItem="dropdown"
            type={getSessionAttendanceColor(parseAttendanceStatus(sessionAttendance.status))}
          >
            {getSessionAttendanceTranslation(parseAttendanceStatus(sessionAttendance.status))}
          </Tag>
        </PopoverMenu.Trigger>
        <PopoverMenu.Content side="bottom" align="end">
          {sessionAttendanceStatus.map((attendance) => {
            return (
              <PopoverMenu.TouchableOption
                title={attendance.label}
                onClick={() => onSubmit(attendance.value)}
                key={attendance.value}
              />
            )
          })}
        </PopoverMenu.Content>
      </PopoverMenu>
    </Box>
  )
}
